import { render, staticRenderFns } from "./AddFriend.vue?vue&type=template&id=72dae87e&scoped=true&lang=pug&"
import script from "./AddFriend.vue?vue&type=script&lang=js&"
export * from "./AddFriend.vue?vue&type=script&lang=js&"
import style0 from "./AddFriend.vue?vue&type=style&index=0&id=72dae87e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dae87e",
  null
  
)

export default component.exports